/*!
 * Yoda.js v1.0.7
 * (c) 2021-present By Kuaishou
 * Released under the ISC License.
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

var baseApis = [{
  namespace: 'system',
  name: 'getDeviceInfo'
}, {
  namespace: 'system',
  name: 'getAppInfo'
}, {
  namespace: 'system',
  name: 'getNetworkType'
}, {
  namespace: 'webview',
  name: 'open'
}, {
  namespace: 'webview',
  name: 'getLaunchParams'
}, {
  namespace: 'webview',
  name: 'close'
}, {
  namespace: 'webview',
  name: 'backOrClose'
}, {
  namespace: 'tool',
  name: 'canIUse'
}, {
  namespace: 'tool',
  name: 'sendRadarLog'
}, {
  namespace: 'tool',
  name: 'checkAppInstalled'
}, {
  namespace: 'tool',
  name: 'launchApp'
}, {
  namespace: 'ui',
  name: 'setTopBarStyle'
}, {
  namespace: 'ui',
  name: 'setTitle'
}, {
  namespace: 'ui',
  name: 'setTopBarButton'
}, {
  namespace: 'ui',
  name: 'removeTopBarButton'
}, {
  namespace: 'ui',
  name: 'setSlideBackBehavior'
}, {
  namespace: 'ui',
  name: 'setPhysicalBackButtonBehavior'
}, {
  namespace: 'ui',
  name: 'showLoading'
}, {
  namespace: 'ui',
  name: 'hideLoading'
}, {
  namespace: 'ui',
  name: 'showToast'
}, {
  namespace: 'ui',
  name: 'showDialog'
}, {
  namespace: 'event',
  name: 'addEventListener'
}, {
  namespace: 'event',
  name: 'removeEventListener'
}, {
  namespace: 'event',
  name: 'dispatchEvent'
}];
var isAndroid = navigator.userAgent.indexOf(' Android ') > -1;
function isLocalApi(namespace, name) {
  return baseApis.filter(function (item) {
    return item.namespace == namespace && item.name == name;
  }).length > 0;
}
var overWriteApis = {
  'tool.checkAppInstalled': {
    before: function before(params) {
      return {
        identifier: params[isAndroid ? 'android' : 'ios']
      };
    }
  }
};

var SafeInteger = Number.MAX_SAFE_INTEGER || 9007199254740991;
var overflow = false;
var _callbackId = 1;

var _instanceId = genInstanceId();
/**
 * ios 客户端目前会将 callbackId 处理为 number
 * 需要尽可能的保证生成的 _instanceId 与其他页面不会重复 & 不会超出 Number.MAX_SAFE_INTEGER
 * 3位随机数 + 9位时间戳 + 4位自增 id
 */


function genInstanceId() {
  var safeIntegerStr = "" + SafeInteger; // 取 3 位随机数避免同一时刻出现重复 & 避免数字溢出

  var maxRandom = Number(safeIntegerStr.slice(0, 3)) - 100;
  var random = Math.floor(Math.random() * maxRandom); // 取 9 位时间戳，保证1周内不会重复

  var date = "" + Date.now();
  var dateStr = date.slice(date.length - 9); // 剩下的都作为自增 id

  var zero = new Array(safeIntegerStr.length - 12).fill(0).join('');
  return Number("" + random + dateStr + zero);
}

function genCallbackId(dicData) {
  var id = genNextId(dicData); // 如果生成的 id 溢出了，从头开始
  // 页面中应该不会有这么多的回调

  if (id >= SafeInteger) {
    overflow = true;
    _callbackId = 1; // 重新生成 insId 尽量减少重复的概率

    _instanceId = genInstanceId();
    return genCallbackId();
  }

  return id;
}

function genNextId(dicData) {
  var callbackId = _instanceId + _callbackId++; // 溢出后需要判断是否已经存在对应的 id

  while (overflow || dicData && dicData[callbackId]) {
    callbackId = _instanceId + _callbackId++;
  }

  return callbackId;
}

function getUUId(dicData) {
  return genCallbackId(dicData);
}

/**
 * 深拷贝
 * @param data 拷贝原对象
 * @returns 拷贝结果
 */
function deepClone(data) {
  return JSON.parse(JSON.stringify(data));
}

/**
 * 节流
 * @param fn 对象函数
 * @param wait 节流时间
 */
/**
 * 防抖
 * @param func
 * @param timeout
 * @returns
 */

function debounce(func, timeout) {
  var _this = this;

  if (timeout === void 0) {
    timeout = 300;
  }

  var timer;
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(_this, args);
    }, timeout);
  };
}

/**
 * 比较版本号
 * @param  {string} source 比较源
 * @param  {string} target 比较目标
 * @return {inter} 前者大返回>0, 相等返回0, 前者小返回<0
 */
function compareVersion(source, target) {
  if (source === void 0) {
    source = '';
  }

  if (target === void 0) {
    target = '';
  }

  var sourceArr = source.split('.');
  var targetArr = target.split('.');

  for (var i = 0; i < targetArr.length; i++) {
    if (sourceArr[i] !== targetArr[i]) {
      var sourceArrNow = isNaN(Number(sourceArr[i])) ? 0 : Number(sourceArr[i]);
      var targetArrNow = isNaN(Number(targetArr[i])) ? 0 : Number(targetArr[i]);
      return sourceArrNow - targetArrNow;
    }
  }

  return 0;
}

var yodaInstance = null;
function setYoda(yoda) {
  yodaInstance = yoda;
}
function getYoda() {
  return yodaInstance;
}

function checkCanUse(namespace, name) {
  return __awaiter(this, void 0, void 0, function () {
    var yoda, checkReuslt;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          yoda = getYoda();
          return [4
          /*yield*/
          , yoda.bridge('tool', 'canIUse', {
            namespace: namespace,
            name: name
          })];

        case 1:
          checkReuslt = _a.sent();
          return [2
          /*return*/
          , checkReuslt.result == '1' && checkReuslt.canUse];
      }
    });
  });
}

function isFunction$1(obj) {
  return typeof obj === 'function';
}

function parsePlatform(userAgent) {
  if (userAgent === void 0) {
    userAgent = '';
  }

  if (userAgent.includes('Android') || userAgent.includes('Adr')) {
    return 'android';
  }

  if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
    return 'ios';
  }

  return 'else';
}

var defaultConfig = {
  timeout: 0,
  method: 'GET'
};
function request$1(config) {
  var promise = new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    var timer;
    var method = config.method,
        header = config.header,
        _a = config.timeout,
        timeout = _a === void 0 ? defaultConfig.timeout : _a,
        data = config.data,
        responseType = config.responseType;
    var url = config.url;
    xhr.responseType = responseType;
    xhr.timeout = timeout;
    xhr.open(method.toUpperCase(), url, true);

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status == 200) {
        if (timer) {
          clearTimeout(timer);
        }

        var response = {
          result: 1,
          data: xhr.response,
          statusCode: xhr.status
        };
        resolve(response);
        xhr = null;
      }
    };

    for (var keyStr in header) {
      xhr.setRequestHeader(keyStr, header[keyStr]);
    }

    xhr.send(data);
    timeout > 0 && (timer = setTimeout(function () {
      xhr.abort();
      timer = null;
      resolve({
        result: 125010,
        profile: {
          isTimeout: true
        }
      });
    }, timeout));
  });
  return promise;
}

var markStr$1 = 'too_performance_';
/**
 * 获取内部调用performance传递id
 * @returns id 字符串
 */

function getPerformanceId() {
  return markStr$1 + getUUId();
}
/**
 * 判断是否是performance的id
 * @param idStr 当前掉用id
 * @returns
 */

function isPerformanceId(callbackId) {
  return callbackId.indexOf(markStr$1) == 0;
}

var markStr = 'event_';
/**
 * 获取内部调用Event传递id
 * @returns id 字符串
 */

function getEventId(dicData) {
  return markStr + getUUId(dicData);
}
/**
 * 获取纯数字的id
 * @param idStr event id 字符串
 * @returns 纯数字字符
 */

function getEventIdOnlyNumber(idStr) {
  return idStr.replace(markStr, '');
}
/**
 * 获取添加了事件前缀的id
 * @param idNumber number id
 * @returns 完整id
 */

function getEventIdByNumber(idNumber) {
  return markStr + String(idNumber);
}
/**
 * 判断是否是Event的id
 * @param idStr 当前掉用id
 * @returns
 */

function isEventId(callbackId) {
  return callbackId.indexOf(markStr) == 0;
}

var _a$1, _b$1, _c, _d;

var isInKSApp = /Kwai/.test(navigator.userAgent);
var _appVersion = '';

if (isInKSApp) {
  _a$1 = navigator.userAgent.match(/Kwai\/([\d+.*]+)/) || [], _b$1 = _a$1[1], _appVersion = _b$1 === void 0 ? '' : _b$1;
} else {
  _c = navigator.userAgent.match(/ksNebula\/([\d+.*]+)/) || [], _d = _c[1], _appVersion = _d === void 0 ? '' : _d;
}

var appVersion = _appVersion;

function is9920() {
  return appVersion.indexOf('9.9.20') == 0;
}

var isInYoda = !!window.__yodaBridge__;
var isOldWebView = !isInYoda;
function isIntegar(obj) {
  return typeof obj === 'number' && obj % 1 === 0;
}
function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}
function isIOS$2() {
  return navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

var eventMQ = {};
function addListener(typeStr, listener, callbackId) {
  var targetTypeListener = eventMQ[typeStr] || {
    callbackId: callbackId,
    eventRecord: {}
  };
  var id = getUUId();
  listener.__yodaCallbackId__[typeStr] = String(id);
  targetTypeListener.eventRecord[id] = listener;
  eventMQ[typeStr] = targetTypeListener;
}
function createCb(type) {
  return function (ret) {
    var targetTypeListener = eventMQ[type];
    Object.keys((targetTypeListener === null || targetTypeListener === void 0 ? void 0 : targetTypeListener.eventRecord) || {}).forEach(function (key) {
      return targetTypeListener.eventRecord[Number(key)](deepClone(ret));
    });
  };
}
function getCallbackIdByType(type) {
  var targetTypeListener = eventMQ[type];
  return getEventIdByNumber(targetTypeListener.callbackId);
}
function removeListener(typeStr, listener) {
  var targetTypeListener = eventMQ[typeStr];
  var callbackId = listener.__yodaCallbackId__[typeStr];
  delete targetTypeListener.eventRecord[Number(callbackId)];
  delete listener.__yodaCallbackId__[typeStr]; // 如果当前不存在监听事件，完全有移除
  // 有新监听，则重建监听对象，防止callbackid 异常

  if (!hasListener(typeStr)) {
    delete eventMQ[typeStr];
  }
}
function hasListener(typeStr) {
  var targetTypeListener = eventMQ[typeStr];
  return Object.keys((targetTypeListener === null || targetTypeListener === void 0 ? void 0 : targetTypeListener.eventRecord) || {}).length > 0;
}

var lifeCycleEnum;

(function (lifeCycleEnum) {
  lifeCycleEnum["start"] = "start";
  lifeCycleEnum["callNative"] = "callNative";
  lifeCycleEnum["callbackFromNativeSuccess"] = "callbackFromNativeSuccess";
  lifeCycleEnum["callbackFromNativeFail"] = "callbackFromNativeFail";
  lifeCycleEnum["callbackFromYoda"] = "callbackFromYoda";
  lifeCycleEnum["callbackError"] = "callbackError";
})(lifeCycleEnum || (lifeCycleEnum = {}));

var logTypeEnum;

(function (logTypeEnum) {
  logTypeEnum[logTypeEnum["invoke"] = 0] = "invoke";
  logTypeEnum[logTypeEnum["callback"] = 1] = "callback";
  logTypeEnum[logTypeEnum["event"] = 2] = "event";
})(logTypeEnum || (logTypeEnum = {}));

var bridgeCode;

(function (bridgeCode) {
  bridgeCode["ok"] = "1";
  bridgeCode["undefinedCallback"] = "201";
  bridgeCode["bridge500"] = "500";
  bridgeCode["bridge404"] = "404";
})(bridgeCode || (bridgeCode = {}));

// 日志缓存池

var logArrayPool = []; // https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=152981099
// Native 上报bridge文档 @张赛
// 使用一帧的时间间隔作为最小上报区间(ms)
// native 侧，考虑bridge 耗时，暂定1s

var logSessionMinTime = 1000 * 1; // 防抖最多次数

var maxTime = 30;

var isLocalBridge = function isLocalBridge(logParams) {
  // 将原本控制getApiList只记录一次的逻辑移除
  // 默认 canIUse 、getApiList  都是本地api
  return ['canIUse', 'getApiList'].indexOf(logParams.name) > -1;
};

var isSendLog = 0
/* unload */
;
var getPageLoadDataPromise; // 数据上报是否已经打开

var loggerSwitch = function loggerSwitch() {
  if (!getPageLoadDataPromise) {
    getPageLoadDataPromise = new Promise(function (res) {
      var _a, _b;

      if (isSendLog == 0
      /* unload */
      ) {
        // window中有注入flag， 直接在window下读取
        if ((_a = window.__yodaCommonDataObject__) === null || _a === void 0 ? void 0 : _a.sampleData) {
          if (typeof window.__yodaCommonDataObject__.sampleData === 'string') {
            try {
              window.__yodaCommonDataObject__.sampleData = JSON.parse(window.__yodaCommonDataObject__.sampleData);
            } catch (e) {
              window.__yodaCommonDataObject__.sampleData = {};
            }
          }

          isSendLog = !!((_b = window.__yodaCommonDataObject__.sampleData) === null || _b === void 0 ? void 0 : _b.bridgeHit) ? 1
          /* open */
          : 2
          /* close */
          ;
          console.log('[散点日志 flag]通过window.__yodaCommonDataObject__.sampleData.bridgeHit获取的值为：', window.__yodaCommonDataObject__.sampleData.bridgeHit);
          res(isSendLog == 1
          /* open */
          );
        } else {
          var yoda = getYoda();
          yoda.bridge('webview', 'getPageLoadData', {}, function (_a) {
            var result = _a.result,
                sampleData = _a.sampleData;

            if (result == 1) {
              isSendLog = (sampleData === null || sampleData === void 0 ? void 0 : sampleData.bridgeHit) ? 1
              /* open */
              : 2
              /* close */
              ;
            } else {
              isSendLog = 2
              /* close */
              ;
            }

            console.log('[散点日志 flag]yoda.webview.getPageLoadData获取的值为：', JSON.stringify(sampleData));
            res(isSendLog == 1
            /* open */
            );
          });
        }
      } else {
        res(isSendLog == 1
        /* open */
        );
      }
    });
  }

  return getPageLoadDataPromise;
};

function sendLog() {
  if (!isInYoda) {
    console.warn('Yoda:非Yoda容器,仅打印log');
    logArrayPool.forEach(function (logItem, index) {
      console.log("Yoda performanceLog[" + index + "]:" + JSON.stringify(logItem));
    });
  } else {
    window.__yodaBridge__.invoke('tool', 'sendPerformanceLog', JSON.stringify({
      data: logArrayPool
    }), getPerformanceId());
  }

  logArrayPool.length = 0;
}
/**
 * 日志上报
 */


var _logger = debounce(function () {
  // const yoda = this;
  sendLog();
}, logSessionMinTime);

function getLog(logParams, dataNow, dateStr) {
  var logData = {
    key: 'bridge',
    value: {},
    dimension: {
      api: logParams.name,
      namespace: logParams.namespace
    },
    event_client_timestamp: dataNow,
    event_trigger_source: 'H5',
    task_identifier: logParams.callbackId,
    is_task_event: true,
    task_status: '' //START 代表此为一系列事件的起点 END

  };

  switch (logParams.type) {
    case logTypeEnum.invoke:
      logData.value.h5_invoke_bridge_time = dataNow;
      logData.task_status = 'START';
      break;

    case logTypeEnum.callback:
      logData.value.h5_receive_callback_time = dataNow;
      logData.value.h5_invoke_bridge_time = dateStr;
      logData.dimension.result_type = logParams.resultCode;
      logData.dimension.result_type && (logData.dimension.result_type = logData.dimension.result_type.toString());
      logData.dimension.error_msg = logParams.errorMsg;
      logData.task_status = 'END';
      break;

    case logTypeEnum.event:
      logData.task_status = 'SUCCESS';
      delete logData.dimension.api;
      delete logData.dimension.namespace;
      logData.dimension.event = '';
      break;
  }

  return logData;
}

function logger(logParams, dateStr) {
  // 当前只在 >= 9.7.40 才会生效
  // if (compareVersion(appVersion, '9.7.40') > 0) return;
  // 限制特定 bridge 和 前端 bridge 的阻止上报
  // getApiList  只上报一次
  // canIUse 不上报
  if (isLocalBridge(logParams)) {
    return;
  }

  var nowDate = Date.now().toString();
  loggerSwitch().then(function (switchFlag) {
    if (!switchFlag) return;
    logArrayPool.push(getLog(logParams, nowDate, dateStr)); // 防止出现大数据提交造成的crash,强制推送

    if (logArrayPool.length >= maxTime) {
      sendLog();
    } else {
      _logger();
    }
  });
  return nowDate;
}
var ua$1 = navigator.userAgent;
var cookie = document.cookie;

function getUAInfo(key) {
  var uaList = {};
  ua$1.split(' ').forEach(function (item) {
    var arr = item.split('/');
    uaList[arr[0]] = arr[1];
  });
  return uaList[key] ? uaList[key] : uaList;
}

function getWebViewType() {
  if (ua$1.indexOf('Android') !== -1) {
    return 'WebView';
  }

  if (ua$1.indexOf('iPhone') !== -1) {
    var uaList = getUAInfo();

    if (uaList.Yoda && uaList.WebViewType === 'WK') {
      return 'YodaWKWebView';
    }

    if (!uaList.Yoda && uaList.WebView === 'WKWebView') {
      return 'WKWebView';
    }

    return 'UIWebView';
  }

  return '';
}

function getCookie(name) {
  var match = cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : '';
}

function sendEventLog(radarProjectId, data, startTime) {
  if (data === void 0) {
    data = {};
  }

  if (startTime === void 0) {
    startTime = 0;
  }

  var yoda = this;
  var duration = new Date().getTime() - startTime;
  yoda.bridge('tool', 'sendRadarLog', {
    removeStashedLog: [],
    sendImmediate: true,
    customData: {
      project_id: radarProjectId || "yoda_kpn_" + getCookie('kpn'),
      url_package: {
        page_type: 2,
        page: location.href,
        params: '',
        identity: getCookie('did')
      },
      data: [{
        key: 'event',
        value: {
          duration: startTime && duration
        },
        dimension: __assign({
          yoda_version: getUAInfo('Yoda') || '',
          webview_type: getWebViewType()
        }, data)
      }]
    }
  });
}

function createSingleDeferred(cb) {
  var resolve;
  var promise = new Promise(function (r) {
    resolve = r;
  });

  if (cb) {
    promise = promise.then(cb, cb);
  }

  return {
    isMulti: false,
    resolve: resolve,
    promise: promise
  };
}

function createMultiDeferred(cb) {
  // 多次调用模式下，promise
  // 只是兼容当前调用方式
  // TODO 文档中需要特殊说明
  var promise = new Promise(function () {});
  return {
    isMulti: true,
    resolve: cb,
    promise: promise
  };
}

var invokeMap = {};
var deferredInvoke = {
  pushMQ: function pushMQ(isMulti, callBackFn, isEvent) {
    if (isMulti === void 0) {
      isMulti = false;
    }

    if (isEvent === void 0) {
      isEvent = false;
    }

    var id = isEvent ? getEventId() : getUUId(invokeMap);
    var deferred = isMulti ? createMultiDeferred(callBackFn) : createSingleDeferred(callBackFn);
    deferred.traceId = String(id);
    invokeMap[id] = deferred;
    return deferred;
  },
  removeMQ: function removeMQ(callbackId) {
    invokeMap[callbackId] = undefined;
  },
  create: function create(namespace, name, isMulti, callBackFn) {
    if (isMulti === void 0) {
      isMulti = false;
    }

    var deferred = this.pushMQ(isMulti, callBackFn);
    deferred.namespace = namespace;
    deferred.name = name; // 创建

    var startTimeStr = logger({
      namespace: namespace,
      name: name,
      type: logTypeEnum.invoke,
      callbackId: deferred.traceId
    });
    invokeMap[deferred.traceId].startTime = startTimeStr;
    return {
      id: deferred.traceId,
      promise: deferred.promise
    };
  },
  resolve: function resolve(id, data) {
    if (isPerformanceId(id)) {
      return;
    }

    if (isEventId(id)) {
      return;
    }

    var deferred = invokeMap[id];

    if (!deferred) {
      // 创建
      // return console.warn('native callback error:', data);
      return;
    } // 发送回调成功日志


    logger({
      namespace: deferred.namespace,
      name: deferred.name,
      type: logTypeEnum.callback,
      callbackId: deferred.traceId,
      resultCode: data.result
    }, deferred.startTime);
    deferred.resolve(data); // 设置成为undefined保证不内存泄露，不用delete是防止回退字典模式

    if (!deferred.isMulti) {
      this.removeMQ(id);
    }
  },
  reject: function reject(id, reason) {
    var deferred = invokeMap[id];

    if (!deferred) {
      // 若无对应调用，不做处理，稍后增加 log
      // return console.warn('native callback error:', reason);
      return;
    } // 以异常信息回调正常业务也逻辑


    deferred.resolve(reason); // 设置成为undefined保证不内存泄露，不用delete是防止回退字典模式

    if (!deferred.isMulti) this.removeMQ(id); // 由于事件的回调result!=1,导致会使事件的回调会走到reject 中

    if (isEventId(id)) {
      return;
    } // 发送回调成功日志


    logger({
      namespace: deferred.namespace,
      name: deferred.name,
      type: logTypeEnum.callback,
      callbackId: deferred.traceId,
      resultCode: reason.result,
      errorMsg: reason.message
    }, deferred.startTime);
  }
};

// 针对 bridge 回调做了一些分类，后续如果有其他类型的 bridge 需要特殊处理再新增分类即可
var BRIDGE_TYPE = {
  noCallbackList: ['popBack', 'exitWebView'],
  onClickList: ['setPhysicalBackButton', 'setTopLeftBtn', 'setTopLeftSecondBtn', 'setTopRightBtn', 'setTopRightSecondBtn'],
  handlerList: ['on', 'off']
}; // 针对主 APP 客户端注入的全局变量，作为 namespace 注册前先进行小驼峰命名转化

var GLOBALVAR_2_NAMESPACE = {
  Kwai: 'kwai',
  KwaiAd: 'kwaiAd',
  KwaiAdThird: 'kwaiAdThird',
  KwaiMerchant: 'kwaiMerchant',
  KwaiLive: 'kwaiLive'
};
var NAMESPACE_2_GLOBALVAR = {
  kwai: 'Kwai',
  kwaiAd: 'KwaiAd',
  kwaiAdThird: 'KwaiAdThird',
  kwaiMerchant: 'KwaiMerchant',
  kwaiLive: 'KwaiLive',
  // 以防使用大写 namespace 进行调用，大写的映射关系也加上
  Kwai: 'Kwai',
  KwaiAd: 'KwaiAd',
  KwaiAdThird: 'KwaiAdThird',
  KwaiMerchant: 'KwaiMerchant',
  KwaiLive: 'KwaiLive'
};
var ADD_CB_PARAMS_LIST = {
  // Android 9.0.30 及以上版本已修复
  home: ['changeActivityTemplate', 'isActivityTabActive']
};

var ua = navigator.userAgent;
var noCallbackList = BRIDGE_TYPE.noCallbackList,
    onClickList = BRIDGE_TYPE.onClickList,
    handlerList = BRIDGE_TYPE.handlerList;
function isFunction(fn) {
  return typeof fn === 'function';
}
function isIOS$1() {
  return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}
/**
 *
 * 生成唯一的id
 * @export
 * @returns
 */

function generateUUID(rc) {
  if (rc === void 0) {
    rc = true;
  } // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523


  var d = new Date().getTime();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }

  var pattern = rc ? 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx' : 'xxxxxxxx_xxxx_4xxx_yxxx_xxxxxxxxxxxx';
  return pattern.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
}
/**
 *
 * 生成临时唯一的方法挂接到window上，给客户端回调用
 * @name generateUUCallbackFunction
 * @private
 * @param {function} callback 回调函数，客户端方法执行完后会执行该方法
 * @param {boolean} notDelete 是否删除当前回调，留在当前页面的内存中
 * @param {string} bridge 的命名空间和方法名，方便后续问题排查
 * @param {string} 回调方法对应的唯一ID
 * @returns
 */

function generateUUCallbackFunction(callback, notDelete, callbackName) {
  var callbackId = generateUUID(false);
  var name = "yoda_kuaishou_plugin_callback_" + callbackName + "_" + callbackId;

  window[name] = function (data) {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
        data.withPermissionCheck = true;
      } catch (e) {
        console.warn(e); // eslint-disable-line
      }
    }

    if (isFunction(callback)) {
      callback.call(window, data);
    } else if (typeof callback === 'string' && isFunction(window[callback])) {
      window[callback].call(window, data);
    }

    if (!notDelete) {
      delete window[name];
    }
  };

  return name;
} // 用于 showDialog 相关 api 中，将回调转化成接口需要的 URL

function transformFuncToURL(btn, callbackName) {
  var tmpBtn = btn;

  if (btn && Array.isArray(btn.actions)) {
    tmpBtn.actions = btn.actions.map(function (action) {
      if (action && action.url && isFunction(action.url)) {
        action.url = generateUUCallbackFunction(action.url, true, callbackName);
      }

      return action;
    });
  }

  return tmpBtn;
}
var handlerCbMap = {}; // 事件相关 api 中处理 handler

function generateHandlerFunction(callback, bridge) {
  var handlerName = '';
  var cb = null;
  Object.keys(handlerCbMap).some(function (cbName) {
    var handlerCb = handlerCbMap[cbName];

    if (handlerCb === callback) {
      cb = handlerCb;
      handlerName = cbName;
      return true;
    }
  }); // 当传递的 handler 回调之前已经挂载过，就不再重新挂载，重新生成 handler 回调名

  if (cb !== callback && callback) {
    var name_1 = generateUUCallbackFunction(callback, true, bridge);
    handlerCbMap[name_1] = callback;
    handlerName = name_1;
  }

  return handlerName;
}
/**
 * bridge 调用参数预处理，针对几类特定 bridge 进行处理
 * @name bridgeParamsHandler
 * @private
 * @param {string} namespace 命名空间
 * @param {string} bridge 桥名
 * @param {Object} 调用参数
 * @param {function} bridge 本身调用的回调
 */

function bridgeParamsHandler(namespace, bridgeName, params, invokeCallback) {
  var handledParams = __assign({}, params);

  var callbackName = namespace + "_" + bridgeName; // 特殊适配 Kwai 等命名空间下 bridge 回调的传递
  // 回调为 onClick 形式的

  if (onClickList.indexOf(bridgeName) > -1) {
    handledParams.onClick = generateUUCallbackFunction(handledParams.onClick, true, callbackName); // 不允许传递任何参数给 native 的
  } else if (noCallbackList.indexOf(bridgeName) > -1) {
    handledParams = null; // 事件类传 handler 的
  } else if (handlerList.indexOf(bridgeName) > -1) {
    var callbackUUid = generateUUCallbackFunction(invokeCallback, false, callbackName); // 调用 off 桥不传 handler 时，则不能传再对其进行处理

    if (handledParams.handler && isFunction(handledParams.handler)) {
      handledParams.handler = generateHandlerFunction(handledParams.handler, callbackName);
    }

    handledParams.callback = callbackUUid; // showDialog
  } else if (bridgeName === 'showDialog') {
    var positiveButton = handledParams.positiveButton,
        negativeButton = handledParams.negativeButton,
        neutralButton = handledParams.neutralButton;

    if (positiveButton) {
      handledParams.positiveButton = transformFuncToURL(positiveButton, callbackName);
    }

    if (negativeButton) {
      handledParams.negativeButton = transformFuncToURL(negativeButton, callbackName);
    }

    if (neutralButton) {
      handledParams.neutralButton = transformFuncToURL(neutralButton, callbackName);
    } // 其他默认都是通过 callback 传给 native

  } else {
    var callbackUUid = generateUUCallbackFunction(invokeCallback, true, callbackName);
    handledParams.callback = handledParams.callback || callbackUUid;
  }

  return handledParams;
}

var __yodaBridgeCallback__ = null;
var guard = {
  setupGrard: function setupGrard() {
    Object.defineProperty && Object.defineProperty(window, '__yodaBridgeCallback__', {
      set: function set(value) {
        if (__yodaBridgeCallback__) {
          throw new Error('当前环境可能存在yoda 多实例的情况，请排查第三方依赖包');
        } else {
          __yodaBridgeCallback__ = value;
        }
      },
      get: function get() {
        return __yodaBridgeCallback__;
      }
    });
  }
};

var isIOS = parsePlatform(window.navigator.userAgent) === 'ios'; // 新旧 bridge 名称的映射

var BridgeMethodMap = {
  requestLocationPermission: 'requestLocationPermissionWithPermissionCheck',
  getLocation: 'getLocationWithPermissionCheck',
  syncLocation: 'syncLocationWithPermissionCheck'
};

function isLocationBridge(namespace, name) {
  return namespace.toLocaleLowerCase() === 'kwai' && !!BridgeMethodMap[name];
}

function hasLocationPermissionBridge(name) {
  return __awaiter(this, void 0, void 0, function () {
    var bridgeName, canUse;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          bridgeName = BridgeMethodMap[name];
          return [4
          /*yield*/
          , checkCanUse('kwai', bridgeName)];

        case 1:
          canUse = _a.sent();
          return [2
          /*return*/
          , canUse];
      }
    });
  });
}

function tranformInvokeConfig(config) {
  return __awaiter(this, void 0, void 0, function () {
    var namespace, name, params;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          namespace = config.namespace, name = config.handlername, params = config.data; // 其他的 bridge

          if (!isLocationBridge(namespace, name)) {
            return [2
            /*return*/
            ];
          }

          return [4
          /*yield*/
          , hasLocationPermissionBridge(name)];

        case 1:
          // 没有新的 bridge
          if (!_a.sent()) {
            // iOS 上旧版本只能用这个
            if (isIOS && name === 'requestLocationPermission') {
              config.handlername = 'requestLocationAuthorization';
            }

            return [2
            /*return*/
            , config];
          } // 调用新的 bridge


          config.handlername = BridgeMethodMap[name];
          config.params = __assign(__assign({}, params), {
            forced_permission_request: params.forced_permission_request || 2
          });
          return [2
          /*return*/
          ];
      }
    });
  });
}

// hybrid.getAndUpdateHybridDetail  -> webview.pageContentInfo
// hybrid.preloadVideoList -> media.pvList
// hybrid.isVideoFullyCached -> media.vReady

var transformNameAndNs = function transformNameAndNs(namespace, name) {
  var result = {
    namespace: namespace,
    name: name
  };

  if (namespace == 'hybrid') {
    if (name == 'getHybridStatus') {
      result.name = 'pageContentStatus';
      result.namespace = 'webview';
    } else if (name == 'getAndUpdateHybridDetail') {
      result.name = 'pageContentInfo';
      result.namespace = 'webview';
    } else if (name == 'preloadVideoList') {
      result.name = 'pvList';
      result.namespace = 'media';
    } else if (name == 'isVideoFullyCached') {
      result.name = 'vReady';
      result.namespace = 'media';
    }
  }

  return result;
};

function changeInfo(namespace, name) {
  if (isIOS$2() && compareVersion('9.10.11', appVersion) <= 0) {
    return transformNameAndNs(namespace, name);
  } else {
    return {
      namespace: namespace,
      name: name
    };
  }
}

function invoke$1(invokeConfig) {
  return __awaiter(this, void 0, void 0, function () {
    var yoda, namespace, name, params, ns, addCbParamsBridges, handlername, isMulti, callback, _a, id, promise, originalNamespace, _invokeCallback, apiList, _b, namespace_1, name_1, canUse_1, invokeData;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          yoda = getYoda();
          return [4
          /*yield*/
          , tranformInvokeConfig(invokeConfig)];

        case 1:
          _c.sent();

          namespace = invokeConfig.namespace, name = invokeConfig.handlername, params = invokeConfig.data;
          ns = NAMESPACE_2_GLOBALVAR[namespace];
          addCbParamsBridges = ADD_CB_PARAMS_LIST[namespace] || [];
          handlername = invokeConfig.handlername, isMulti = invokeConfig.isMulti, callback = invokeConfig.callback;
          _a = deferredInvoke.create(namespace, handlername, isMulti, callback), id = _a.id, promise = _a.promise; // TODO 确定逻辑后处理 临时添加 活动 namespace

          if (ns || addCbParamsBridges.indexOf(name) > -1 || namespace == 'sf2022') {
            originalNamespace = ns || namespace;

            _invokeCallback = function _invokeCallback(res) {
              invokeCallback(id, res);
            };

            invokeConfig.namespace = originalNamespace; // 参数预处理

            invokeConfig.data = bridgeParamsHandler(originalNamespace, name, params, _invokeCallback); // 比较版本号
            // 7730 以上版本不需要做兼容处理
            // 兼容方式注册的桥，双端只关注 params.callback，yoda 方式注册的桥只关注 invoke callbackId
            // if (appVersion && compareVersion(appVersion, '7.7.30') < 0) {
            // 在 js-sdk 层将桥调用的回调方法转到 params 后，需要将 callbackId 重置下
            // 主要处理部分只回调一次的桥（回调执行一次后会被 delete），如果 params.callback 和 invokeCallback 指向一个回调
            // 可能会导致 params.callback 还未执行，回调已被 delete
            // 临时回调函数只在这个地方有声明，原sdk、plugin 并未 指定该 callback
            // const tmpCbKey = '__yoda_kuaishou_plugin_tmp_cb__';
            // yoda._callbacks[tmpCbKey] = yoda._callbacks[tmpCbKey] || noop;
            // invokeConfig.callbackId = tmpCbKey;
            // 需要额外挂到 window 上是因为 iOS 可能会去 window 上找该回调
            //     window.__yoda_kuaishou_plugin_tmp_cb__ = noop;
            // }
          }

          if (namespace === 'tool' && Object.keys(yoda._apisMap).length !== 0 && ['getApiList', 'canIUse'].indexOf(name) > -1) {
            if (name === 'getApiList') {
              setTimeout(function () {
                window.__yodaBridgeCallback__(id, yoda._apisMap);
              });
            }

            if (name === 'canIUse') {
              apiList = yoda._apisMap.apiList;
              _b = changeInfo(params.namespace, params.name), namespace_1 = _b.namespace, name_1 = _b.name;
              canUse_1 = apiList.some(function (api) {
                var ns = api.namespace;
                var bridgeName = api.name;
                return ns.toLocaleLowerCase() == namespace_1.toLocaleLowerCase() && bridgeName === name_1;
              });
              setTimeout(function () {
                window.__yodaBridgeCallback__(id, JSON.stringify({
                  result: 1,
                  canUse: canUse_1
                }));
              });
            }
          } else {
            invokeData = changeInfo(invokeConfig.namespace, handlername);

            window.__yodaBridge__.invoke(invokeData.namespace, invokeData.name, JSON.stringify(invokeConfig.data || {}), String(id));
          }

          return [2
          /*return*/
          , promise];
      }
    });
  });
}

function invokeCallback(id, res) {
  var data = typeof res == 'string' ? JSON.parse(res) : res;
  data.withPermissionCheck = true;

  if (data.result === 1) {
    deferredInvoke.resolve(id, data);
  } else {
    deferredInvoke.reject(id, data);
  }
} // 开启守卫


guard.setupGrard(); // 挂载接收 native 回调事件

window.__yodaBridgeCallback__ = invokeCallback;
var yodaInvoke = {
  invoke: invoke$1
};

// bridge 映射关系
var bridgeMap = {};
var apis = {};
var isInit = false;

function getApis() {
  if (isInit) return apis;
  isInit = true; // 为避免像 ks-bridge 那样为增加新的 bridge 调用而频繁发版，改为遍历 native 注入的 Kwai 等全局变量上的 bridge

  for (var globalVar in GLOBALVAR_2_NAMESPACE) {
    for (var property in window[globalVar]) {
      var ns = GLOBALVAR_2_NAMESPACE[globalVar];

      if (ns) {
        var config = {}; // kwai.emit data 参数仅支持 string，但由于实际使用习惯直接传对象，故需要 stringify 处理下

        if (ns === 'kwai' && property === 'emit') {
          config.before = function (param) {
            if (param && typeof param.data === 'object' && param.data !== null) {
              param.data = JSON.stringify(param.data);
            }

            return param;
          };
        }

        bridgeMap[ns] = bridgeMap[ns] || {};
        bridgeMap[ns][property] = config; // globalVar 也需要注入，保证不影响类似 yoda.Kwai.xxx 这种方式调用

        bridgeMap[globalVar] = bridgeMap[globalVar] || {};
        bridgeMap[globalVar][property] = config;
      }
    }
  }

  apis = __assign({
    webview: {
      open: {
        ksName: 'loadUrlOnNewPage',
        before: function before(opt) {
          var url = opt.url,
              type = opt.type;
          return {
            url: url,
            type: type || 'back'
          };
        }
      },
      close: function () {
        var ksName = isIOS$1() ? 'exitCurrentWebview' : 'exitWebView';
        return {
          ksName: ksName
        };
      }(),
      backOrClose: {
        ksName: 'popBack'
      },
      openKsWebview: {
        ksName: 'loadUrlOnNewPage'
      }
    },
    tool: {
      canIUse: {
        ksName: 'isSupport',
        after: function after(res) {
          return {
            result: 1,
            canUse: !!res
          };
        }
      },
      setClipBoard: {}
    },
    ui: {
      setSlideBackBehavior: {
        ksName: 'setSlideBack',
        before: function before(opt) {
          var behavior = opt.behavior;
          return {
            enabled: behavior !== 'none'
          };
        }
      },
      showToast: {},
      showDialog: {
        before: function before(opt, cb) {
          var _a = opt.title,
              title = _a === void 0 ? '' : _a,
              _b = opt.content,
              content = _b === void 0 ? '' : _b,
              _c = opt.confirmButtonText,
              confirmButtonText = _c === void 0 ? '确定' : _c,
              _d = opt.cancelButtonText,
              cancelButtonText = _d === void 0 ? '取消' : _d,
              _e = opt.showCancelButton,
              showCancelButton = _e === void 0 ? true : _e;
          var param = {
            title: title,
            content: content,
            positiveButton: {
              text: confirmButtonText,
              colorType: 'positive',
              actions: [{
                actionType: 'JS_CALLBACK',
                url: function url() {
                  cb({
                    result: 1,
                    target: 'confirm'
                  });
                }
              }]
            }
          };

          if (showCancelButton) {
            param.negativeButton = {
              text: cancelButtonText,
              colorType: 'negative',
              actions: [{
                actionType: 'JS_CALLBACK',
                url: function url() {
                  cb({
                    result: 1,
                    target: 'cancel'
                  });
                }
              }]
            };
          }

          return param;
        }
      },
      showBottomSheet: {}
    },
    event: {
      dispatchEvent: {
        ksName: 'emit',
        before: function before(param) {
          if (param && typeof param.data === 'object' && param.data !== null) {
            param.data = JSON.stringify(param.data);
          }

          return param;
        }
      }
    },
    merchant: {
      getSidToken: {},
      reqSessionStickyOnTopWithThread: {},
      querySessionIsStickyOnTop: {}
    },
    mediaInteraction: {
      saveImage: {},
      selectImage: {}
    }
  }, bridgeMap);
  return apis;
}

// invoke hook

var noop = function noop(res) {};

var origin = function origin(o) {
  return o;
};

function callNative(name, bridgeName, options, cb) {
  var opts = bridgeParamsHandler(name, bridgeName, options, cb); //  isSupport 为 ks-bridge 自定义方法，插件不再依赖 ks-bridge，故需要单独处理 isSupport 调用

  if (bridgeName === 'isSupport') {
    var checkedBridge = options.name;
    cb(!!(window[name] && window[name][checkedBridge]));
    return;
  } else if (!window[name] || !window[name][bridgeName]) {
    // 当该方法不存在时, 直接回调
    handleError(opts);
    return;
  }

  try {
    // opts 为空表示当前 bridge 调用不能传任何参数，否则 native 调用报错
    if (!opts) {
      window[name][bridgeName]();
    } else {
      var strParam = void 0;

      try {
        strParam = JSON.stringify(opts);
      } catch (e) {
        e.message += ' in JSON.stringify';
        throw e;
      }

      window[name][bridgeName](strParam);
    }
  } catch (e) {
    handleError(opts);
    setTimeout(function () {
      e.message += " (from yoda-kuaishou-plugin window." + name + "." + bridgeName + ")"; // 异步上报错误 不阻断当前代码

      throw e;
    });
  }
}

function handleError(opts) {
  var language = window.navigator && (window.navigator.languages || window.navigator.language) || [];
  var errorMsg = language.length && language.indexOf('zh') === -1 && language.indexOf('zh-CN') === -1 ? 'Error occurred, please upgrade your app' : '出错啦, 请升级客户端至最新版本';
  opts.callback && window[opts.callback] && window[opts.callback](JSON.stringify({
    result: 127000,
    error_msg: errorMsg
  }));
}
// 所以在 beforeInvoke 中直接走 window.xxx 调用
// export async function invoke(invokeConfig: any) {
//     console.log(`invokeConfig:`, JSON.stringify(invokeConfig));
//     await tranformInvokeConfig(invokeConfig);
//     let { namespace: ns, api, data: params, callback } = invokeConfig;
//     if (ns == 'tool' && invokeConfig.handlername == 'canIUse') {
//         return canIUse(params.namespace, params.name, callback);
//     }
//     const globalVar = NAMESPACE_2_GLOBALVAR[ns] || 'Kwai';
//     api = api || invokeConfig;
//     const { handlername, ksName, before = origin, after = origin } = api;
//     const bridgeName = ksName || handlername;
//     if (isFunction(before)) {
//         // 对调用参数进行预处理
//         params = before(params);
//     }
//     let cb = noop;
//     if (isFunction(callback)) {
//         cb = (res: any) => {
//             let handledRes = res;
//             if (isFunction(after)) {
//                 // 对响应参数进行预处理
//                 handledRes = after(res);
//             }
//             callback(handledRes);
//         };
//     }
//     if (bridgeName) {
//         callNative(globalVar, bridgeName, params, cb);
//     } else {
//         throw new Error('invoke: 未指定调用 bridge');
//     }
// }


function invoke(ns, api, params, callback) {
  var globalVar = NAMESPACE_2_GLOBALVAR[ns] || 'Kwai';
  var name = api.name,
      ksName = api.ksName,
      _a = api.before,
      before = _a === void 0 ? origin : _a,
      _b = api.after,
      after = _b === void 0 ? origin : _b;
  var bridgeName = ksName || name;

  if (isFunction(before)) {
    // 对调用参数进行预处理
    params = before(params);
  }

  var cb = noop;

  if (isFunction(callback)) {
    cb = function cb(res) {
      var handledRes = res;

      if (isFunction(after)) {
        // 对响应参数进行预处理
        handledRes = after(res);
      }

      callback(handledRes);
    };
  }

  if (bridgeName) {
    callNative(globalVar, bridgeName, params, cb);
  } else {
    throw new Error('invoke: 未指定调用调用 bridge');
  }
}
function _beforeInvoke(invokeConfig) {
  var yoda = this;
  return new Promise(function (res) {
    // call 全局变量上挂载的方法, 不执行next
    var namespace = invokeConfig.namespace,
        name = invokeConfig.handlername,
        callback = invokeConfig.callback;
    var params = invokeConfig.params || invokeConfig.data;
    var apis = getApis();
    var apiMap = apis[namespace];
    var api = apiMap && apiMap[name];

    if (api) {
      // TODO 检查 params 结构，防止后续解析时报错
      var param = params || {};
      api.name = name;
      invoke.call(yoda, namespace, api, param, function (bridgeRes) {
        callback && callback(bridgeRes);
        res(bridgeRes);
      });
    } else {
      var bridgeRes = {
        result: 125004
      };
      res(bridgeRes);

      if (callback && typeof callback == 'function') {
        callback(bridgeRes);
      } else {
        throw new Error("invoke\uFF1Ayoda." + namespace + "." + name + "\u4E0D\u5B58\u5728");
      }
    }
  });
}
var uiWebview = {
  invoke: _beforeInvoke
};

var bridge = {
  invoke: isOldWebView ? uiWebview.invoke : yodaInvoke.invoke
};

var Direction;

(function (Direction) {
  Direction["x"] = "x";
  Direction["y"] = "y";
  Direction["z"] = "z";
})(Direction || (Direction = {}));

var SHAKE_EVENT = 'native_yoda_shaked';
var SHAKE_START_EVENT = 'native_yoda_shake_start';
var SHAKE_END_EVENT = 'native_yoda_shake_end';
var JUDGE_STOP_TIME = 1000;
var DEFAULT_SETTING = {
  level: 2,
  times: 3,
  intervalTime: 1300,
  iOSIntervalTime: 500,
  androidIntervalTime: 1300,
  isEmitImmediately: true
};
var ANDROID_LEVEL_MAP = {
  1: {
    basic: 13,
    total: 450
  },
  2: {
    basic: 16,
    total: 700
  },
  3: {
    basic: 20,
    total: 1100
  }
};
var IOS_LEVEL_MAP = {
  1: {
    basic: 9,
    total: 220
  },
  2: {
    basic: 12,
    total: 400
  },
  3: {
    basic: 14,
    total: 500
  }
};

var ShakeHandler = function () {
  function ShakeHandler(props) {
    var _this = this;

    this.shakeConfig = {};
    this.shakedArr = [];
    this.isChecking = false;
    this.nowStatus = {
      x: 0,
      y: 0,
      z: 0
    };
    this.lastStatus = {
      x: 0,
      y: 0,
      z: 0
    };
    this.checkIsShakeStoped = false;
    this.notEmitButShaked = true;
    this.isShakeStarted = false;
    this.isAndroid = false;
    this.isArrivedConfigStandard = false;
    this.levelMap = ANDROID_LEVEL_MAP;
    this.dispatchEvent = null;
    this.setStillShaking = debounce(function () {
      return _this.notShaking();
    }, JUDGE_STOP_TIME);
    this.dispatchEvent = props.dispatchEvent;
    this.isAndroid = props.isAndroid;
    this.levelMap = this.isAndroid ? ANDROID_LEVEL_MAP : IOS_LEVEL_MAP;
  }

  ShakeHandler.prototype.setOptions = function (options) {
    if (options) {
      this.shakeConfig = __assign(__assign({}, DEFAULT_SETTING), options); // iOS 和 Android重力感应的灵敏度等都不太一样，数值分端调试，并在次数上允许小量误差

      this.shakeConfig.times = this.isAndroid ? this.shakeConfig.times - 1 : (this.shakeConfig.times - 1) * 2;
      this.shakeConfig.intervalTime = this.isAndroid ? this.shakeConfig.androidIntervalTime : this.shakeConfig.iOSIntervalTime;
    } else {
      this.shakeConfig = __assign({}, DEFAULT_SETTING);
    }
  };

  ShakeHandler.prototype.resetShakeStatus = function (isStoped) {
    this.shakedArr = [];
    this.isChecking = false;
    this.notEmitButShaked = false;

    if (isStoped) {
      this.isArrivedConfigStandard = false;
      this.isShakeStarted = false;
    }
  };

  ShakeHandler.prototype.checkIsShake = function (result) {
    var _this = this;

    this.isChecking = true;
    Object.keys(this.nowStatus).forEach(function (key) {
      return _this.nowStatus[key] = result[key] * 9.8;
    });

    if (this.judgeArrivedTerminal()) {
      this.lastStatus = {
        x: 0,
        y: 0,
        z: 0
      };
      this.handleShakeHappend();
      this.setStillShaking();
      this.isChecking = false;
      return;
    }

    if (this.judgeLikelyShake()) {
      this.handleArrivedStandard();
    } else {
      this.isChecking = false;
    }
  };

  ShakeHandler.prototype.judgeLikelyShake = function () {
    var _a = this.nowStatus,
        x = _a.x,
        y = _a.y,
        z = _a.z;
    var _b = this.levelMap[this.shakeConfig.level],
        basic = _b.basic,
        total = _b.total;
    return x > basic || y > basic || z > basic || x * x + y * y + z * z > total;
  }; // 用加速度变化最大的方向作为判断依据，确认加速度是否反向，从而判定是否到达一次摇动的端点


  ShakeHandler.prototype.judgeArrivedTerminal = function () {
    var _this = this;

    var maxDiffVal = 0;
    var diffVal = 0;
    var toJudgeKey = Direction.x; // 获取加速度变化最大的方向

    Object.keys(this.nowStatus).forEach(function (key) {
      diffVal = Math.abs(_this.lastStatus[key] - _this.nowStatus[key]);

      if (maxDiffVal < diffVal) {
        toJudgeKey = key;
        maxDiffVal = diffVal;
      }
    });

    if (this.lastStatus[toJudgeKey] * this.nowStatus[toJudgeKey] < 0) {
      return true;
    }

    return false;
  };

  ShakeHandler.prototype.handleArrivedStandard = function () {
    this.lastStatus = __assign({}, this.nowStatus);
    this.checkIsShakeStoped = false;
    this.setStillShaking();
  };

  ShakeHandler.prototype.handleShakeHappend = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!this.isShakeStarted) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.dispatchEvent({
              type: SHAKE_START_EVENT,
              data: {}
            })];

          case 1:
            _a.sent();

            _a.label = 2;

          case 2:
            this.isShakeStarted = true;
            this.updateShakedArr(new Date().getTime());
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ShakeHandler.prototype.notShaking = function () {
    this.checkIsShakeStoped = true;
    this.checkDoDelayEmit();
  };

  ShakeHandler.prototype.updateShakedArr = function (newTimeStamp) {
    var intervalTime = this.shakeConfig.intervalTime;

    if (this.shakedArr.length > 0) {
      if (newTimeStamp - this.shakedArr[this.shakedArr.length - 1] <= intervalTime) {
        this.shakedArr.push(newTimeStamp);
      } else {
        this.shakedArr = [];
        this.isChecking = false;
      }
    } else {
      this.shakedArr.push(newTimeStamp);
    } // 允许少许误差


    if (this.shakedArr.length >= this.shakeConfig.times) {
      this.handleArrivedEmitStandard();
    } else {
      this.isChecking = false;
    }
  };

  ShakeHandler.prototype.handleArrivedEmitStandard = function () {
    this.isArrivedConfigStandard = true;
    this.resetShakeStatus();

    if (this.shakeConfig.isEmitImmediately) {
      this.dispatchEvent({
        type: SHAKE_EVENT,
        data: {}
      });
    } else {
      this.notEmitButShaked = true;
    }
  };

  ShakeHandler.prototype.checkDoDelayEmit = function () {
    if (this.notEmitButShaked && this.checkIsShakeStoped && !this.shakeConfig.isEmitImmediately) {
      this.dispatchEvent({
        type: SHAKE_EVENT,
        data: {}
      });
    }

    if (this.isShakeStarted) {
      this.dispatchEvent({
        type: SHAKE_END_EVENT,
        data: {
          isArrivedConfigStandard: this.isArrivedConfigStandard
        }
      });
    }

    this.resetShakeStatus(true);
  };

  return ShakeHandler;
}();

var interval = 60;
var shakeHandler = null;
var checkIsShake = null;

function startMonitorShake() {
  return __awaiter(this, void 0, void 0, function () {
    var yoda, startAccelerometerRes, eventRes;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          yoda = this;
          return [4
          /*yield*/
          , yoda.bridge('system', 'startAccelerometer', {
            interval: interval
          })];

        case 1:
          startAccelerometerRes = _a.sent();
          checkIsShake = shakeHandler.checkIsShake.bind(shakeHandler);
          return [4
          /*yield*/
          , yoda.bridge('event', 'addEventListener', {
            type: 'accelerometer-change',
            listener: checkIsShake
          })];

        case 2:
          eventRes = _a.sent();

          if (startAccelerometerRes.result === 1 && eventRes.result !== 1) {
            stopMonitorShake.bind(yoda)();
          }

          if (startAccelerometerRes.result !== 1 || eventRes.result !== 1) {
            throw new Error("\u6447\u4E00\u6447\u521D\u59CB\u5316\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002AccelerometerRes:" + JSON.stringify(startAccelerometerRes) + ";eventRes:" + JSON.stringify(eventRes));
          }

          return [2
          /*return*/
          ];
      }
    });
  });
}

function validateOption(options) {
  if (!options) {
    return;
  }

  var level = options.level,
      times = options.times;
      options.intervalTime;
      var isEmitImmediately = options.isEmitImmediately; // android 和 iOS 级别类型一致

  if (level !== undefined && !ANDROID_LEVEL_MAP[level]) {
    throw new Error('请传入正确的level，可选值为1、2、3');
  }

  if (times !== undefined) {
    if (!isIntegar(times)) {
      throw new Error('times应为整数');
    }

    if (times < 1) {
      throw new Error('times应大于1');
    }
  }

  if (isEmitImmediately !== undefined) {
    if (typeof isEmitImmediately !== 'boolean') {
      throw new Error('isEmitImmediately应为boolean类型');
    }
  }
}

function initShakeHandler(options) {
  return __awaiter(this, void 0, void 0, function () {
    var yoda, dispatchEvent;

    var _this = this;

    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          yoda = this;
          return [4
          /*yield*/
          , checkCanUse.bind(yoda)('system', 'startAccelerometer')];

        case 1:
          if (!_a.sent()) {
            throw new Error('当前APP暂不支持摇一摇');
          }

          if (shakeHandler) {
            throw new Error('当前存在尚未结束监听的摇一摇');
          }

          dispatchEvent = function dispatchEvent(params) {
            return __awaiter(_this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                return [2
                /*return*/
                , yoda.bridge('event', 'dispatchEvent', params)];
              });
            });
          };

          shakeHandler = new ShakeHandler({
            dispatchEvent: dispatchEvent,
            isAndroid: parsePlatform(navigator.userAgent) === 'android'
          });
          validateOption(options);
          shakeHandler.setOptions(options);
          shakeHandler.resetShakeStatus();
          return [4
          /*yield*/
          , startMonitorShake.bind(yoda)()];

        case 2:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  });
}
function stopMonitorShake() {
  return __awaiter(this, void 0, void 0, function () {
    var yoda, eventRes, stopRes;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          yoda = this;
          return [4
          /*yield*/
          , checkCanUse.bind(yoda)('system', 'stopAccelerometer')];

        case 1:
          if (!_a.sent()) {
            throw new Error('当前APP暂不支持摇一摇');
          }

          shakeHandler = null;
          return [4
          /*yield*/
          , yoda.bridge('event', 'removeEventListener', {
            type: 'accelerometer-change',
            listener: checkIsShake
          })];

        case 2:
          eventRes = _a.sent();
          return [4
          /*yield*/
          , yoda.bridge('system', 'stopAccelerometer')];

        case 3:
          stopRes = _a.sent();

          if (eventRes.result !== 1 || stopRes.result !== 1) {
            throw new Error("\u6447\u4E00\u6447\u505C\u6B62\u76D1\u542C\u5931\u8D25\u3002stopRes:" + JSON.stringify(stopRes) + ";eventRes:" + JSON.stringify(eventRes));
          }

          return [2
          /*return*/
          ];
      }
    });
  });
}

var _a, _b;
var yodaCustomEvent = {
  shaked: SHAKE_EVENT
};
var eventToInitMap = (_a = {}, _a[yodaCustomEvent.shaked] = initShakeHandler, _a);
var handleEventUnregisterMap = (_b = {}, _b[yodaCustomEvent.shaked] = stopMonitorShake, _b);

var isInitEvent = false; // 添加事件监听

function addEventListener$1(params, callback) {
  var _a;

  var baseType = params.type,
      listener = params.listener;
  var type = typeof baseType === 'string' ? baseType : baseType.type;
  var options = typeof baseType === 'string' ? {} : baseType.options;
  (_a = eventToInitMap[type]) === null || _a === void 0 ? void 0 : _a.bind(this)(options); // initEvent()

  !listener.__yodaCallbackId__ && (listener.__yodaCallbackId__ = {}); // 保持原有判断逻辑不变，若当前lisetener

  if (listener.__yodaCallbackId__[type]) {
    throw new Error("addEventListener " + type + " \u7684 listener \u5DF2\u7ECF\u88AB\u7ED1\u5B9A\u8FC7\u4E86");
  }

  var registerForNativeListener = hasListener(type);
  var callBackId;
  var returnPromise; // call native 新增监听

  if (!registerForNativeListener) {
    var deferredIns = deferredInvoke.pushMQ(true, createCb(type), true);
    callBackId = parseInt(getEventIdOnlyNumber(deferredIns.traceId));
    returnPromise = bridge.invoke({
      namespace: 'event',
      handlername: 'addEventListener',
      data: {
        type: type,
        listener: String(deferredIns.traceId)
      },
      isMulti: false,
      callback: callback
    });
  } else {
    // 前端维护，直接回调
    isFunction$1(callback) && callback({
      result: 1
    });
  }

  addListener(type, listener, callBackId);
  return returnPromise;
} // 移除事件监听


function removeEventListener$1(params, callback) {
  var _a;

  var type = params.type,
      listener = params.listener;
  (_a = handleEventUnregisterMap[type]) === null || _a === void 0 ? void 0 : _a.bind(this)();
  var resultPromise;

  if (listener.__yodaCallbackId__) {
    var callbackId = getCallbackIdByType(type); // 移除前端监听

    removeListener(type, listener); // 若当前不包含监听

    if (!hasListener(type)) {
      // 移除native 侧监听
      resultPromise = bridge.invoke({
        namespace: 'event',
        handlername: 'removeEventListener',
        data: {
          type: type,
          listener: callbackId
        },
        isMulti: false,
        callback: callback
      }); // 移除js 侧监听

      deferredInvoke.removeMQ(callbackId);
    }
  }

  return resultPromise;
}

function initEvent$4() {
  if (isInitEvent) return;
  isInitEvent = true;
  var yoda = this;
  var eventNamespace = yoda.event;

  if (eventNamespace && eventNamespace.addEventListener) {
    eventNamespace.addEventListener = function (type, listener, callback) {
      return addEventListener$1.bind(yoda)({
        type: type,
        listener: listener
      }, callback);
    };
  }

  if (eventNamespace && eventNamespace.removeEventListener) {
    eventNamespace.removeEventListener = function (type, listener, callback) {
      return removeEventListener$1.bind(yoda)({
        type: type,
        listener: listener
      }, callback);
    };
  }
}
var yodaEvent = [{
  namespace: 'event',
  name: 'addEventListener',
  headler: addEventListener$1
}, {
  namespace: 'event',
  name: 'removeEventListener',
  headler: removeEventListener$1
}];

// yoda 的 resume、pause，对应到旧 webview 中对应多种事件
var eventsMap = {
  resume: ['native_foreground', 'native_reentry'],
  pause: ['native_background', 'native_leave']
};

function addEventListener(type, handler, callback) {
  return new Promise(function (res) {
    if (eventsMap[type]) {
      eventsMap[type].forEach(function (eventName) {
        invoke('kwai', {
          name: 'on'
        }, {
          type: eventName,
          handler: handler
        }, function (bridgeRes) {
          callback && callback(bridgeRes);
          res(bridgeRes);
        });
      });
    } else {
      invoke('kwai', {
        name: 'on'
      }, {
        type: type,
        handler: handler
      }, function (bridgeRes) {
        callback && callback(bridgeRes);
        res(bridgeRes);
      });
    }
  });
}

function removeEventListener(type, handler, callback) {
  return new Promise(function (res) {
    if (eventsMap[type]) {
      eventsMap[type].forEach(function (eventName) {
        invoke('kwai', {
          name: 'off'
        }, {
          type: eventName,
          handler: handler
        }, function (bridgeRes) {
          callback && callback(bridgeRes);
          res(bridgeRes);
        });
      });
    } else {
      return invoke('kwai', {
        name: 'off'
      }, {
        type: type,
        handler: handler
      }, function (bridgeRes) {
        callback && callback(bridgeRes);
        res(bridgeRes);
      });
    }
  });
}

var initEvent$3 = function initEvent() {
  var yoda = this;
  yoda.event = yoda.event || {};
  yoda.event.addEventListener = addEventListener.bind(yoda);
  yoda.event.removeEventListener = removeEventListener.bind(yoda);
};
var webviewEvent = [{
  namespace: 'event',
  name: 'addEventListener',
  headler: function headler(params, callback) {
    return addEventListener(params.type, params.listener, callback);
  }
}, {
  namespace: 'event',
  name: 'removeEventListener',
  headler: function headler(params, callback) {
    return removeEventListener(params.type, params.listener, callback);
  }
}];

var eventLocal = yodaEvent;
var _initEvent = initEvent$4;

if (!isInYoda) {
  eventLocal = webviewEvent;
  _initEvent = initEvent$3;
}

var initEvent$2 = _initEvent;
var events = eventLocal;

/**
 * 创建 api 列表
 */

function createFeApiMap(apiCreatorMap) {
  return __awaiter(this, void 0, void 0, function () {
    var onCreateError, apiList, result;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          onCreateError = function onCreateError(apiKey, error) {
            return console.error("[yoda] create fe api: " + apiKey + " failed, ", error);
          };

          apiList = Object.keys(apiCreatorMap);
          return [4
          /*yield*/
          , Promise.all(apiList.reduce(function (apiResult, apiKey) {
            try {
              var api = apiCreatorMap[apiKey]();

              if (isPromise(api)) {
                api.catch(function (e) {
                  onCreateError(apiKey, e);
                  return null;
                });
              }

              return __spreadArray(__spreadArray([], apiResult), [api]);
            } catch (e) {
              onCreateError(apiKey, e);
            }

            return apiResult;
          }, []))];

        case 1:
          result = _a.sent();
          return [2
          /*return*/
          , result.reduce(function (apiObj, apiResult, index) {
            var _a;

            if (!apiResult) {
              return apiObj;
            }

            return __assign(__assign({}, apiObj), (_a = {}, _a[apiList[index]] = apiResult, _a));
          }, {})];
      }
    });
  });
}

var FeApiCommonResultCode = {
  notSupport: -1000,
  argsError: 125007
};

var createArgsError = function createArgsError(message) {
  return {
    result: FeApiCommonResultCode.argsError,
    message: message
  };
};

var MaxDuration = 600000;
var SupportedFormat = ['m4a'];
var RecorderMsg = {
  startConfigEmpty: 'start 方法需要传入 config 参数',
  startDurationEmpty: 'duration 应该为大于等于 0 的整数',
  startDurationLimit: "duration \u4E0D\u80FD\u8D85\u8FC7\u6700\u5927\u503C " + MaxDuration + "\uFF0810\u5206\u949F\uFF09",
  startFormat: "format \u53EA\u652F\u6301: " + SupportedFormat.join(';')
};

function canUseRecorder() {
  return __awaiter(this, void 0, void 0, function () {
    var canUseEvent, canUseAudioStart, canUseAudioStop;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , checkCanUse('event', 'addEventListener')];

        case 1:
          canUseEvent = _a.sent();
          return [4
          /*yield*/
          , checkCanUse('system', 'startAudioRecorder')];

        case 2:
          canUseAudioStart = _a.sent();
          return [4
          /*yield*/
          , checkCanUse('system', 'stopAudioRecorder')];

        case 3:
          canUseAudioStop = _a.sent();
          return [2
          /*return*/
          , canUseEvent && canUseAudioStart && canUseAudioStop];
      }
    });
  });
}
/**
 * 每次 start 都需要给客户端传一个 taskId
 * 后续事件会携带这个 taskId
 * @returns
 */


function genTaskId() {
  return "" + Date.now();
}
/** start bridge 参数校验 */


function getStartConfigError(config) {
  if (!config) {
    return createArgsError(RecorderMsg.startConfigEmpty);
  }

  if (!Number.isInteger(config.duration) || config.duration <= 0) {
    return createArgsError(RecorderMsg.startDurationEmpty);
  }

  if (config.duration > MaxDuration) {
    return createArgsError(RecorderMsg.startDurationLimit);
  }

  if (!config.format || !SupportedFormat.includes(config.format)) {
    return createArgsError(RecorderMsg.startFormat);
  }

  return null;
}
/**
 * 监听客户端事件
 * 每个事件全局只监听一次，在前端 dispatch
 * @param yoda
 * @returns
 */


function initEvent$1() {
  var yoda = getYoda();
  var listened = false; // 各个事件的 listener

  var ListenerMap = {
    start: [],
    stop: [],
    error: []
  }; // 当前需要处理的 event id (只触发了 start 但没有 stop / error)

  var EventIdMap = new Map(); // 延迟监听客户端事件

  var listenNativeEvent = function listenNativeEvent() {
    if (listened) {
      return;
    }

    listened = true;
    yoda.bridge('event', 'addEventListener', {
      type: 'native_audio_recorder_start',
      listener: dispatchEvent('start')
    });
    yoda.bridge('event', 'addEventListener', {
      type: 'native_audio_recorder_stop',
      listener: dispatchEvent('stop')
    });
    yoda.bridge('event', 'addEventListener', {
      type: 'native_audio_recorder_error',
      listener: dispatchEvent('error')
    });
  };

  var addEventListener = function addEventListener(type) {
    return function (cb) {
      listenNativeEvent();
      ListenerMap[type].push(cb);
      return function () {
        return ListenerMap[type] = ListenerMap[type].filter(function (item) {
          return item !== cb;
        });
      };
    };
  };

  var dispatchEvent = function dispatchEvent(type) {
    return function (e) {
      // 过滤非自己主动 start 的事件
      if (!EventIdMap.has(e.taskId)) {
        return;
      } // 录音结束，不再监听对应的事件


      if (type === 'stop' || type === 'error') {
        EventIdMap.delete(e.taskId);
      }

      ListenerMap[type].forEach(function (item) {
        return !!e ? item(e) : item();
      });
    };
  };

  return {
    onStart: addEventListener('start'),
    onStop: addEventListener('stop'),
    onError: addEventListener('error'),
    addListenId: function addListenId(id) {
      return EventIdMap.set(id, true);
    },
    rmListenId: function rmListenId(id) {
      return EventIdMap.delete(id);
    }
  };
}

var createRecorderManager = function createRecorderManager() {
  return __awaiter(void 0, void 0, void 0, function () {
    var yoda, _a, onStart, onStop, onError, addListenId, rmListenId, start, stop;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4
          /*yield*/
          , canUseRecorder()];

        case 1:
          if (!_b.sent()) {
            return [2
            /*return*/
            , null];
          }

          yoda = getYoda();
          _a = initEvent$1(), onStart = _a.onStart, onStop = _a.onStop, onError = _a.onError, addListenId = _a.addListenId, rmListenId = _a.rmListenId;

          start = function start(config) {
            return __awaiter(void 0, void 0, void 0, function () {
              var configError, taskId, res;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    configError = getStartConfigError(config);

                    if (configError) {
                      return [2
                      /*return*/
                      , configError];
                    }

                    taskId = genTaskId();
                    addListenId(taskId);
                    return [4
                    /*yield*/
                    , yoda.bridge('system', 'startAudioRecorder', __assign(__assign({}, config), {
                      taskId: taskId
                    }))];

                  case 1:
                    res = _a.sent(); // 创建失败，删除 id

                    if (!res || res.result !== 1) {
                      rmListenId(taskId);
                    }

                    return [2
                    /*return*/
                    , res];
                }
              });
            });
          };

          stop = function stop() {
            return yoda.bridge('system', 'stopAudioRecorder', {});
          };

          return [2
          /*return*/
          , {
            start: start,
            stop: stop,
            onStart: onStart,
            onStop: onStop,
            onError: onError
          }];
      }
    });
  });
};

var FileManagerMsg = {
  readFileConfigMiss: 'readFile 方法需要传入 config 参数',
  filePathEmpty: 'filePath 参数不能为空',
  encodingEmpty: 'encoding 参数不能为空'
};

function canUseFileManager() {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , checkCanUse('system', 'readFile')];

        case 1:
          return [2
          /*return*/
          , _a.sent()];
      }
    });
  });
}

function getReadFileConfigError(config) {
  if (!config) {
    return createArgsError(FileManagerMsg.readFileConfigMiss);
  }

  if (!config.filePath) {
    return createArgsError(FileManagerMsg.filePathEmpty);
  }

  if (!config.encoding) {
    return createArgsError(FileManagerMsg.encodingEmpty);
  }

  return null;
}

var createFileManager = function createFileManager() {
  return __awaiter(void 0, void 0, void 0, function () {
    var yoda;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          yoda = getYoda();
          return [4
          /*yield*/
          , canUseFileManager()];

        case 1:
          if (!_a.sent()) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , {
            readFile: function readFile(config) {
              var configError = getReadFileConfigError(config);

              if (configError) {
                return configError;
              }

              return yoda.bridge('system', 'readFile', config);
            }
          }];
      }
    });
  });
};

var FEApiMap = {
  // 录音
  recorderManager: createRecorderManager,
  // 文件
  fileManager: createFileManager
};

var YodaFeApiKey = 'feApi';

function initFEApi() {
  return __awaiter(this, void 0, void 0, function () {
    var yoda, apiMap;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          yoda = getYoda();
          return [4
          /*yield*/
          , createFeApiMap(FEApiMap)];

        case 1:
          apiMap = _a.sent();
          yoda[YodaFeApiKey] = apiMap;
          return [2
          /*return*/
          ];
      }
    });
  });
}

var getApiListPending = false;
function init$2() {
  var _this = this;

  var yoda = this;

  var already = function already() {
    if (getApiListPending) return;
    getApiListPending = true;
    var startTime = Date.now();
    yoda.register({
      namespace: 'tool',
      name: 'getApiList'
    });
    yoda.tool.getApiList({}, function (_a) {
      var result = _a.result,
          apiList = _a.apiList;
      return __awaiter(_this, void 0, void 0, function () {
        var l;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              // 方法不存在时使用兜底api
              if (result !== 1) {
                apiList = baseApis;
              }

              if (result === 1) {
                yoda._apisMap = {
                  result: result,
                  apiList: apiList
                };
              }

              for (l = apiList.length; l--;) {
                yoda.register(deepClone(apiList[l]));
              }

              initEvent$2.bind(yoda)();
              return [4
              /*yield*/
              , initFEApi()];

            case 1:
              _b.sent(); // 触发 yoda.ready`


              readyResolve(null);
              yoda.isReady = true;
              sendEventLog.call(yoda, '2fa790a375', {
                name: 'yoda_auto_register',
                category: 'yoda_js_sdk',
                result_type: result,
                extra_info: JSON.stringify({
                  res: yoda._apisMap,
                  apiLength: apiList.length
                })
              }, startTime);
              return [2
              /*return*/
              ];
          }
        });
      });
    });
  }; // 对已经注入bridge的 直接ready


  if (window.__yodaBridge__) {
    already();
  } else {
    window.__yodaBridgeReady__ = already;
  }
}

var init$1 = function init() {
  initEvent$3.bind(this)();
  var apis = getApis();

  for (var namespace in apis) {
    var apiList = apis[namespace];

    for (var name_1 in apiList) {
      var api = apiList[name_1];

      if (api) {
        this.register({
          namespace: namespace,
          name: name_1,
          multiCallback: true
        });
      }
    }
  }

  readyResolve(null);
};

var webviewInit = {
  init: init$1
};

var initEvent = init$2;

if (isOldWebView) {
  initEvent = webviewInit.init;
}

var init = initEvent;

var readyPromise;
var readyResolve;
readyPromise = new Promise(function (res) {
  readyResolve = res;
});

function ready(callback) {
  var yoda = this;

  if (callback) {
    readyPromise.then(callback);
  } // 若ready被执行，则触发原有的bridge 初始化逻辑


  !yoda.isReady && init.bind(this)();
  return readyPromise;
}

var checkRequestPromise;
function checkRequest() {
  var yoda = getYoda();

  if (!checkRequestPromise) {
    checkRequestPromise = yoda.bridge('tool', 'getCommonConfig', {});
  }

  return checkRequestPromise;
}

function requestBridge(params, callback) {
  var _a, _b, _c;

  return __awaiter(this, void 0, void 0, function () {
    var yoda, header, method, data, url, timeout, responseType, checkresult, sendHeader, requestData;
    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          yoda = getYoda();
          header = params.header, method = params.method, data = params.data, url = params.url, timeout = params.timeout, responseType = params.responseType;

          if (!responseType) {
            responseType = 'json';
          }

          if (!method) {
            method = 'get';
          } // 只支持get 、 post


          if (['get', 'post'].indexOf(method.toLocaleLowerCase()) == -1) {
            throw Error('tool.request only supports get/post ');
          }

          url = parseUrl(url, params.params);
          timeout = parseTimeout(timeout);
          if (!(yoda.isInYoda && !!((_a = window.__yodaBridge__) === null || _a === void 0 ? void 0 : _a.invoke) && (isIOS$1() || compareVersion('9.9.40', appVersion) < 0))) return [3
          /*break*/
          , 3];
          return [4
          /*yield*/
          , checkRequest()];

        case 1:
          checkresult = _d.sent();
          if (!(checkresult.result == 1 && ((_c = (_b = checkresult.configData) === null || _b === void 0 ? void 0 : _b.bridge) === null || _c === void 0 ? void 0 : _c.enableRequestProxy))) return [3
          /*break*/
          , 3];
          sendHeader = parseHeader(header, true);
          return [4
          /*yield*/
          , bridge.invoke({
            namespace: 'tool',
            handlername: 'request',
            data: {
              method: method,
              data: JSON.stringify(data),
              url: url,
              header: sendHeader,
              timeout: timeout,
              responseType: responseType
            },
            isMulti: false,
            callback: callback
          })];

        case 2:
          requestData = _d.sent();

          if (responseType == 'json' && typeof requestData.data == 'string') {
            try {
              requestData.data = JSON.parse(requestData.data);
            } catch (e) {
              requestData.data = {};
            }
          } // 暂时屏蔽掉bridge 的超时操作


          if (requestData.result == '125010') {
            !requestData.profile && (requestData.profile = {});
            requestData.profile.isTimeout = true;
          }

          if (requestData.result != '1') {
            requestData = requestAajx({
              header: header,
              data: data,
              method: method,
              url: url,
              timeout: timeout,
              responseType: responseType,
              callback: callback
            });
          }

          return [2
          /*return*/
          , requestData];

        case 3:
          return [2
          /*return*/
          , requestAajx({
            header: header,
            data: data,
            method: method,
            url: url,
            timeout: timeout,
            responseType: responseType,
            callback: callback
          })];
      }
    });
  });
}

function requestAajx(_a) {
  var header = _a.header,
      data = _a.data,
      method = _a.method,
      url = _a.url,
      timeout = _a.timeout,
      responseType = _a.responseType,
      callback = _a.callback;
  return __awaiter(this, void 0, void 0, function () {
    var sendHeader, requestPromise;
    return __generator(this, function (_b) {
      sendHeader = parseHeader(header);
      requestPromise = request$1({
        method: method,
        data: JSON.stringify(data),
        url: url,
        header: sendHeader,
        timeout: timeout,
        responseType: responseType
      });

      if (callback) {
        requestPromise = requestPromise.then(function (data) {
          callback(data);
        });
      }

      return [2
      /*return*/
      , requestPromise];
    });
  });
}

function parseHeader(header, withBridge) {
  if (withBridge === void 0) {
    withBridge = false;
  }

  !header && (header = {});
  var contentTypeStr = 'content-type';
  var headerKeys = Object.keys(header || {});
  var contentTypeArray = ['application/json', 'application/x-www-form-urlencoded'];
  headerKeys.forEach(function (keyStr) {
    var valueStr = header[keyStr];

    if (keyStr.toLocaleLowerCase() == contentTypeStr) {
      var cacheIndex = contentTypeArray.indexOf(valueStr.toLocaleLowerCase());

      if (cacheIndex == -1) {
        throw Error("header:" + keyStr + " \u4EC5\u652F\u6301 application/json\u3001application/x-www-form-urlencoded");
      } else {
        // 移除当前
        delete header[keyStr];
        header[keyStr.toLocaleLowerCase()] = valueStr.toLocaleLowerCase();
      }
    } else if (['accept', 'accept-encoding', 'accept-language'].indexOf(keyStr.toLowerCase()) !== -1) {
      delete header[keyStr];
      header[keyStr.toLocaleLowerCase()] = valueStr.toLocaleLowerCase();
    }
  }); // 如果当前传入数据，未包含content-type，则设置未 json 数据

  !header[contentTypeStr] && (header[contentTypeStr] = contentTypeArray[0]);

  if (withBridge) {
    !header['accept'] && (header['accept'] = '*/*');
    !header['accept-encoding'] && (header['accept-encoding'] = 'gzip, deflate');
    !header['accept-language'] && (header['accept-language'] = navigator.language ? navigator.language : navigator.languages.join(','));
    !header['user-agent'] && (header['user-agent'] = (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || '');
  }

  return header;
}

function parseTimeout(timeout) {

  return timeout;
}

function parseUrl(urlStr, params) {
  var result = urlStr;

  if (!/^http/.test(urlStr)) {
    result = [window.location.origin, urlStr].join('');
  }

  var paramsArray = [];

  if (params) {
    for (var keyStr in params) {
      paramsArray.push(keyStr + "=" + params[keyStr]);
    }
  } else {
    return result;
  }

  return "" + result + (result.indexOf('?') > -1 ? '&' : '?') + paramsArray.join('&');
}

var request = [{
  namespace: 'tool',
  name: 'request',
  headler: function headler(params, callback) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , requestBridge(params, callback)];
      });
    });
  }
}];

function excuLocalEvent(namespace, name, params, callback) {
  var findApi = events.filter(function (eventItem) {
    return name == eventItem.name && namespace == eventItem.namespace;
  });

  if (findApi.length > 1) {
    console.warn(namespace + "." + name + " \u5171\u6CE8\u518C" + findApi.length + "\u4E2A\u4E8B\u4EF6\uFF0C\u8BF7\u68C0\u67E5\u662F\u5426\u7B26\u5408\u9884\u671F");
  }

  return findApi.length > 0 ? findApi[0].headler.bind(this)(params, callback) : undefined;
}
function excuLocalBridge(namespace, name, params, callback) {
  var yoda = getYoda();

  if (yoda.mockApiList && !yoda.isInYoda) {
    var mockApi_1 = yoda.mockApiList.filter(function (eventItem) {
      return name == eventItem.name && namespace == eventItem.namespace;
    });

    if (mockApi_1.length == 1) {
      var resultPromise = new Promise(function (res) {
        res(mockApi_1[0].headler());
      });

      if (callback) {
        resultPromise.then(callback);
      }

      return resultPromise;
    } else if (mockApi_1.length > 0) {
      console.warn("mock\u4E8B\u4EF6\uFF1A" + namespace + "." + name + " \u5171\u6CE8\u518C" + mockApi_1.length + "\u4E2A\u4E8B\u4EF6\uFF0C\u8BF7\u68C0\u67E5\u662F\u5426\u7B26\u5408\u9884\u671F");
    }
  }

  var findApi = request.filter(function (eventItem) {
    return name == eventItem.name && namespace == eventItem.namespace;
  });

  if (findApi.length > 1) {
    console.warn(namespace + "." + name + " \u5171\u6CE8\u518C" + findApi.length + "\u4E2A\u4E8B\u4EF6\uFF0C\u8BF7\u68C0\u67E5\u662F\u5426\u7B26\u5408\u9884\u671F");
  }

  return findApi.length > 0 ? findApi[0].headler.bind(this)(params, callback) : undefined;
}

/**
 * 构造bridge方法
 * @param config bridge 基本信息
 * @returns bridge 调用方法
 */

function createBridge(config) {
  var yoda = this; // 某些方法需要添加 before 或者 after 等

  var overWriteApi = overWriteApis[config.namespace + '.' + config.name];

  if (overWriteApi) {
    config = __assign(__assign({}, config), overWriteApi);
  }

  return function (params, option, _callback, isNewCall) {
    // logger(config.namespace, config.name, lifeCycleEnum.start);
    if (typeof option === 'function') {
      _callback = option;
    }

    if (config.before) {
      // before可能会报错 直接抛出异常
      params = config.before(params);
    } // 兼容 callback & config.after 同时存在case


    if (config.after) {
      _callback && (_callback = function callback(ret) {
        _callback(config.after(ret));
      });
    }

    var returnPromise;
    var localEventResult;

    if (isNewCall) {
      localEventResult = excuLocalEvent.bind(yoda)(config.namespace, config.name, params, _callback);
    }

    if (!localEventResult) {
      localEventResult = excuLocalBridge.bind(yoda)(config.namespace, config.name, params, _callback);
    }

    if (!localEventResult) {
      // 通信
      returnPromise = bridge.invoke.bind(yoda)({
        namespace: config.namespace,
        handlername: config.name,
        data: params,
        isMulti: (config === null || config === void 0 ? void 0 : config.multiCallback) || (option === null || option === void 0 ? void 0 : option.multiCallback),
        callback: _callback
      });
    } else {
      returnPromise = localEventResult;
    }

    return returnPromise;
  };
}

/**
 * Yoda 2.0 调用bridge 方式
 * @param namespace 命名空间
 * @param name bridge 名称
 * @param params 调用参数
 * @param option 配置信息【可选】
 * @param callback 回调函数【可选】
 * @returns promise
 */

function invokeBridge(callData) {
  var namespace = callData.namespace,
      name = callData.name,
      params = callData.params,
      option = callData.option,
      callback = callData.callback;
  return createBridge.bind(this)({
    namespace: namespace,
    name: name
  })(params, option, callback, true);
}

/**
 * 注册yoda bridge
 * @param config bridge配置
 */

function register$1(config) {
  var yoda = this;
  var namespaceObj = yoda[config.namespace] = yoda[config.namespace] || {}; // 事件挂载

  namespaceObj[config.name] = createBridge.bind(this)(config); // 存入注册列表

  var apiList = yoda.apiList || [];
  apiList.push(config);
}

// register hook
function _beforeRegister(registerApi) {
  var yoda = this;

  if (yoda.isInYoda) {
    var _a = registerApi || {},
        namespace = _a.namespace,
        name_1 = _a.name;

    var ns = GLOBALVAR_2_NAMESPACE[namespace];

    if (ns) {
      if (ns === 'kwai' && name_1 === 'emit') {
        registerApi.before = function (param) {
          if (param && typeof param.data === 'object' && param.data !== null) {
            param.data = JSON.stringify(param.data);
          }

          return param;
        };
      } // 兼容 kwai、kwaiLive 等命名空间大小写


      registerApi.namespace = ns;
    }
  }

  return registerApi;
}
function _afterRegister(registerApi) {
  var yoda = this;

  if (yoda.isInYoda) {
    var _a = registerApi || {},
        namespace = _a.namespace,
        name_2 = _a.name;

    var globalVar = NAMESPACE_2_GLOBALVAR[namespace];

    if (globalVar) {
      // 为使得桥命名空间是小驼峰格式而改变了 yoda 上注册的命名空间
      // 为了不影响类似 yoda.Kwai.xxx 这种方式调用，将 yoda.kwai.xxx 赋值给 yoda.Kwai
      yoda[globalVar] = yoda[globalVar] || {};
      yoda[globalVar][name_2] = yoda[namespace][name_2];
    }
  }
}

function register (registerApi) {
  if (isInYoda) {
    registerApi = _beforeRegister.bind(this)(registerApi);
  }

  register$1.bind(this)(registerApi);

  if (isInYoda) {
    _afterRegister.bind(this)(registerApi);
  }
}

function invokeAndroid9920(callData) {
  return new Promise(function (res) {
    var yoda = getYoda();
    yoda.ready(function () {
      if (yoda[callData.namespace] && yoda[callData.namespace][callData.name]) {
        yoda[callData.namespace][callData.name](callData.params, callData.option, callData.callback).then(function (invokeData) {
          res(invokeData);
        });
      } else {
        var result404 = {
          result: 125004
        };
        callData.callback && callData.callback(result404);
        res(result404);
      }
    });
  });
}

var yoda = {
  isInYoda: isInYoda,
  isReady: false,
  ready: ready,
  invoke: bridge.invoke,
  plugin: function plugin() {
    // 使用plugin，意味着是使用的版本<v1.0
    // 直接调用init
    init.bind(this)();
  },
  register: register,
  _apisMap: {},
  startMock: function startMock(mockApiList) {
    yoda.mockApiList = mockApiList;
  },
  bridge: function bridge(namespace, name, params, callback) {
    var callParams = {
      namespace: namespace,
      name: name,
      params: params,
      callback: callback ? function (data) {
        callback(data);
      } : null
    }; // 兼容 @wangzhaoqi 9920 调用一个不存在的bridge 无法回调问题

    if (is9920() && !isIOS$2() && !isLocalApi(namespace, name)) {
      return invokeAndroid9920(callParams);
    } else {
      return invokeBridge(callParams);
    }
  },

  /**
   * 调用bridge
   * @param namespace 命名空间
   * @param name bridge 名字
   * @param params 参数
   * @param callback 回调函数
   * @returns
   */
  multiBridge: function multiBridge(namespace, name, params, callback) {
    var callParams = {
      namespace: namespace,
      name: name,
      params: params,
      option: {
        multiCallback: true
      },
      callback: callback ? function (data) {
        callback(data);
      } : null
    }; // 兼容 @wangzhaoqi 9920 调用一个不存在的bridge 无法回调问题

    if (is9920() && !isIOS$2() && !isLocalApi(namespace, name)) {
      return invokeAndroid9920(callParams);
    } else {
      return invokeBridge(callParams);
    }
  }
}; // 缓存yoda对象

setYoda(yoda);

export { yoda as default };
